export const REQUEST_LICENSES = 'REQUEST_LICENSES';
export type REQUEST_LICENSES = typeof REQUEST_LICENSES;

export const REQUEST_LICENSES_SUCCESS = 'REQUEST_LICENSES_SUCCESS';
export type REQUEST_LICENSES_SUCCESS = typeof REQUEST_LICENSES_SUCCESS;

export const REQUEST_LICENSES_FAILED = 'REQUEST_LICENSES_FAILED';
export type REQUEST_LICENSES_FAILED = typeof REQUEST_LICENSES_FAILED;

export const REQUEST_PASSWORDS = 'REQUEST_PASSWORDS';
export type REQUEST_PASSWORDS = typeof REQUEST_PASSWORDS;

export const REQUEST_PASSWORDS_SUCCESS = 'REQUEST_PASSWORDS_SUCCESS';
export type REQUEST_PASSWORDS_SUCCESS = typeof REQUEST_PASSWORDS_SUCCESS;

export const REQUEST_PASSWORDS_FAILED = 'REQUEST_PASSWORDS_FAILED';
export type REQUEST_PASSWORDS_FAILED = typeof REQUEST_PASSWORDS_FAILED;

export const REQUEST_CERTIFICATES = 'REQUEST_CERTIFICATES';
export type REQUEST_CERTIFICATES = typeof REQUEST_CERTIFICATES;

export const REQUEST_CERTIFICATES_SUCCESS = 'REQUEST_CERTIFICATES_SUCCESS';
export type REQUEST_CERTIFICATES_SUCCESS = typeof REQUEST_CERTIFICATES_SUCCESS;

export const REQUEST_CERTIFICATES_FAILED = 'REQUEST_CERTIFICATES_FAILED';
export type REQUEST_CERTIFICATES_FAILED = typeof REQUEST_CERTIFICATES_FAILED;

export const REQUEST_TENANTS = 'REQUEST_TENANTS';
export type REQUEST_TENANTS = typeof REQUEST_TENANTS;

export const REQUEST_TENANTS_SUCCESS = 'REQUEST_TENANTS_SUCCESS';
export type REQUEST_TENANTS_SUCCESS = typeof REQUEST_TENANTS_SUCCESS;

export const REQUEST_TENANTS_FAILED = 'REQUEST_TENANTS_FAILED';
export type REQUEST_TENANTS_FAILED = typeof REQUEST_TENANTS_FAILED;

export const ADD_PASSWORD = 'ADD_PASSWORD';
export type ADD_PASSWORD = typeof ADD_PASSWORD;

export const ADD_PASSWORD_SUCCESS = 'ADD_PASSWORD_SUCCESS';
export type ADD_PASSWORD_SUCCESS = typeof ADD_PASSWORD_SUCCESS;

export const ADD_PASSWORD_FAILED = 'ADD_PASSWORD_FAILED';
export type ADD_PASSWORD_FAILED = typeof ADD_PASSWORD_FAILED;

export const ADD_LICENSE = 'ADD_LICENSE';
export type ADD_LICENSE = typeof ADD_LICENSE;

export const ADD_CERTIFICATE = 'ADD_CERTIFICATE';
export type ADD_CERTIFICATE = typeof ADD_CERTIFICATE;
